module.exports = __webpack_public_path__ + "static/media/creativity-meets-experience.cdb37a43.png";